export function initHeroAvi() {
    const container = document.getElementById('heroAvi');
    if (!container) return;

    const face = container.querySelector('.hero-avi-face') as HTMLElement;
    const eyes = container.querySelectorAll('.hero-avi-eye') as NodeListOf<HTMLElement>;
    const mouth = container.querySelector('.hero-avi-mouth') as HTMLElement;

    let isDragging = false;
    let currentTarget: HTMLElement | null = null;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;

    // --- Face Interaction (Dragging) ---

    const startDrag = (e: MouseEvent | TouchEvent, target: HTMLElement) => {
        isDragging = true;
        currentTarget = target;
        const pos = 'touches' in e ? e.touches[0] : e as MouseEvent;
        startX = pos.clientX - currentX;
        startY = pos.clientY - currentY;
        target.style.transition = 'none';
    };

    const onDrag = (e: MouseEvent | TouchEvent) => {
        if (!isDragging || !currentTarget) return;
        const pos = 'touches' in e ? e.touches[0] : e as MouseEvent;
        
        currentX = pos.clientX - startX;
        currentY = pos.clientY - startY;

        const limit = 60;
        const dist = Math.sqrt(currentX * currentX + currentY * currentY);
        
        // Angry trigger
        if (dist > 40) {
            face.classList.add('angry');
        } else if (!isDragging) {
             // Handled by return-to-normal in stopDrag, but defensive here
        }

        if (dist > limit) {
            currentX *= limit / dist;
            currentY *= limit / dist;
        }

        currentTarget.style.transform = `translate(${currentX}px, ${currentY}px) scale(${1 + dist/200})`;
        
        // Squish effect for mouth
        if (currentTarget === mouth) {
            currentTarget.style.height = `${8 + Math.abs(currentY) / 2}px`;
            currentTarget.style.width = `${80 - Math.abs(currentX) / 2}px`;
        }
    };

    const stopDrag = () => {
        if (!isDragging || !currentTarget) return;
        isDragging = false;
        face.classList.remove('angry');
        currentTarget.style.transition = 'transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275), width 0.5s, height 0.5s';
        currentTarget.style.transform = 'translate(0, 0)';
        
        if (currentTarget === mouth) {
            currentTarget.style.height = '8px';
            currentTarget.style.width = '80px';
        }
        
        currentX = 0;
        currentY = 0;
        currentTarget = null;
    };

    // Attach listeners
    [...eyes, mouth].forEach(el => {
        el.addEventListener('mousedown', (e) => startDrag(e, el));
        el.addEventListener('touchstart', (e) => startDrag(e, el), { passive: true });
    });

    window.addEventListener('mousemove', onDrag);
    window.addEventListener('touchmove', onDrag, { passive: false });
    window.addEventListener('mouseup', stopDrag);
    window.addEventListener('touchend', stopDrag);

    // --- Eye Following ---
    window.addEventListener('mousemove', (e) => {
        if (isDragging) return;
        
        eyes.forEach(eye => {
            const rect = eye.getBoundingClientRect();
            const eyeX = rect.left + rect.width / 2;
            const eyeY = rect.top + rect.height / 2;
            
            const angle = Math.atan2(e.clientY - eyeY, e.clientX - eyeX);
            const dist = Math.min(10, Math.hypot(e.clientX - eyeX, e.clientY - eyeY) / 20);
            
            const pupil = eye.querySelector('.pupil') as HTMLElement;
            if (pupil) {
                pupil.style.transform = `translate(${Math.cos(angle) * dist}px, ${Math.sin(angle) * dist}px)`;
            }
        });
    });

    // --- Random Blinking ---
    const blink = () => {
        face.classList.add('blink');
        setTimeout(() => {
            face.classList.remove('blink');
            setTimeout(blink, 2000 + Math.random() * 5000);
        }, 150);
    };
    setTimeout(blink, 2000);

    // --- Random Idle Emotions ---
    const emotions: ('happy' | 'thinking' | 'sad' | 'neutral')[] = ['happy', 'thinking', 'neutral'];
    const triggerEmotion = () => {
        if (isDragging) {
            setTimeout(triggerEmotion, 3000);
            return;
        }

        const emotion = emotions[Math.floor(Math.random() * emotions.length)];
        
        // Use existing setEmotion if available or apply classes manually
        face.classList.remove('happy', 'sad', 'thinking');
        if (emotion !== 'neutral') face.classList.add(emotion);
        
        // Adjust eyes based on emotion
        eyes.forEach(eye => {
            eye.classList.remove('narrow', 'large');
            if (emotion === 'happy') eye.classList.add('large');
            if (emotion === 'thinking') eye.classList.add('narrow');
        });

        // Mouth adjustment for emotions
        if (emotion === 'happy') {
            mouth.style.height = '12px';
            mouth.style.borderRadius = '50%';
        } else if (emotion === 'thinking') {
            mouth.style.height = '4px';
            mouth.style.width = '40px';
        } else {
            mouth.style.height = '8px';
            mouth.style.width = '80px';
            mouth.style.borderRadius = '20px';
        }

        // Return to neutral after 2-4 seconds
        setTimeout(() => {
            if (!isDragging) {
                face.classList.remove('happy', 'sad', 'thinking');
                eyes.forEach(eye => eye.classList.remove('narrow', 'large'));
                mouth.style.height = '8px';
                mouth.style.width = '80px';
                mouth.style.borderRadius = '20px';
            }
            // Next emotion in 5-10 seconds
            setTimeout(triggerEmotion, 5000 + Math.random() * 5000);
        }, 2000 + Math.random() * 2000);
    };
    setTimeout(triggerEmotion, 3000);
}

// Global hook
(window as any).initHeroAvi = initHeroAvi;
